import { FETCH_QUERYCONDITIONS_INFO } from './filter-box';
import { RESET_DATA_PANEL } from './constants';
const PRODUCT_DATA_SHOW_DETAIL = 'PRODUCT_DATA_SHOW_DETAIL';
// 切换数据面板
const PRODUCT_DATA_TOGGLE_SHOW_TYPE = 'PRODUCT_DATA_TOGGLE_SHOW_TYPE';
const PRODUCT_DATA_WHOLE_UPDATE = 'PRODUCT_DATA_WHOLE_UPDATE';

export function actionShowProductDataDetail(wareId, wareName) {
  return {
    type: PRODUCT_DATA_SHOW_DETAIL,
    payload: {
      wareId,
      wareName,
    },
  };
}

export function actionToggleShowType(payload) {
  return {
    type: PRODUCT_DATA_TOGGLE_SHOW_TYPE,
    payload,
  };
}

export function updateWholeProductData(payload) {
  return {
    type: PRODUCT_DATA_WHOLE_UPDATE,
    payload,
  };
}

export const SHOW_TYPES = {
  LIST: '1',
  DETAIL: '2',
};

const initialState = {
  downloadUrl: null,
  showType: SHOW_TYPES.LIST,
  list: [],
  expandIndex: 0,
  pageSize: 10,
  currentPage: 1,
  // 被选中的activityid
  chckedWareId: '',
  chckedWareName: '',
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case PRODUCT_DATA_TOGGLE_SHOW_TYPE:
      return Object.assign({}, state, { showType: payload });
    case PRODUCT_DATA_SHOW_DETAIL:
      return Object.assign({}, state, {
        checkedWareId: payload.wareId,
        checkedWareName: payload.wareName,
        showType: SHOW_TYPES.DETAIL,
      });
    case PRODUCT_DATA_WHOLE_UPDATE:
      return Object.assign({}, state, payload);
    case RESET_DATA_PANEL:
      return initialState;
    case FETCH_QUERYCONDITIONS_INFO:
      return Object.assign({}, { showType: SHOW_TYPES.LIST });
    default:
      return state;
  }
};
